<template>
  <div class="full-width full-height Main">
    <MuiNavbar
      fixed
      height="70"
      class="Navbar"
    >
      <template slot="center">
        <img
          :src="assets.navbar_logo"
        >
      </template>
    </MuiNavbar>
    <div
      v-if="isLoaded"
      class="pt-5"
    >
      <PreferredLocationsComponent
        :data="data"
        :gmap-api="gmapApi"
        :change="changeAddress"
        :update="addNewLocation"
        :delete="deleteLocation"
      />
    </div>
  </div>
</template>

<script>

import { gmapApi } from 'vue2-google-maps';

import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';

import { MuiNavbar } from '@ubeeqo/motion-ui';
import { PREFERRED_LOCATIONS_MODULE } from '@/constants/modules';
import PreferredLocationsModule from '../Booking/store/PreferredLocations/PreferredLocationsModule';
import PreferredLocationsComponent from '../Booking/components/PreferredLocations/PreferredLocationsComponent';
import MAIN_VIEW_MODEL from '@/views/MAIN_VIEW_MODEL';

export default {
  components: {
    MuiNavbar,
    PreferredLocationsComponent,
  },
  computed: {
    gmapApi: () => gmapApi(),
    ...mapState('Setup', {
      assets: state => state.assets,
    }),
    ...mapState(PREFERRED_LOCATIONS_MODULE, {
      data: state => state.data,
      isLoaded: state => state.STATUS.LOADED,
    }),
    ...mapState(MAIN_VIEW_MODEL.userAccount, {
      userUuid: state => state.data.uuid,
    }),
  },
  mounted() {
    this.getPreferredLocations(this.userUuid);
  },

  methods: {
    ...mapActions(
      PREFERRED_LOCATIONS_MODULE,
      {
        postPreferredLocation: PreferredLocationsModule.ACTIONS.postPreferredLocation,
        getPreferredLocations: PreferredLocationsModule.ACTIONS.getPreferredLocations,
        deletePreferredLocation: PreferredLocationsModule.ACTIONS.deletePreferredLocation,
      },
    ),
    ...mapMutations(
      PREFERRED_LOCATIONS_MODULE, {
        address: PreferredLocationsModule.MUTATIONS.address,
      },
    ),
    addNewLocation(type) {
      const location = {
        type,
        address: this.data[type].address.address,
        alias: type,
      };
      this.postPreferredLocation({ location, userUuid: this.userUuid });
    },
    deleteLocation(value) {
      this.deletePreferredLocation(value);
    },
    changeAddress(value) {
      this.address(value);
    },
  },
};
</script>
